<div class="ops-job-details-main-container">
  <div class="back-container">
    <div class="back-inline-div" (click)="navigateBack()">
      <emerald-icon [icon]="'arrow_back'"></emerald-icon>
      <span class="back-text">Back</span>
    </div>
  </div>

  <div class="view-details">
    <div class="Job-details">
      <div class="search-child">
        <h3 class="heading">
          {{ jobTitle }}
          <span> ({{ hiringRequestId }})</span>
        </h3>
        <p class="text">Candidates Submitted: {{ totalCount }}</p>
        <p class="text">Project Name: {{ projectName }}</p>
        <p class="text">Primary Skills: {{ primarySkills }}</p>
        <p class="text">Hiring Manager: {{ hiringManagerName }}</p>
      </div>
      <div class="jobdetail-button" *ngIf="jobDescriptionFilePath">
        <emerald-button
          [type]="'Light'"
          [label]="'Job Description'"
          [size]="'Large'"
          (onClick)="job_Description('jobDescription')"
          [icon]="'download'"
        ></emerald-button>
      </div>
    </div>
    <div class="job-details-search">
      <div class="search-bar-container">
        <div class="search-child">
          <emerald-input
            [label]="'Search'"
            [trailingIcon]="'search'"
            (keyup)="applyJobDetails($event)"
            [value]="filterValue"
            ><emerald-icon
              *ngIf="filterValue?.length && filterValue.length > 0"
              [icon]="'close'"
              (click)="clearInput()"
            ></emerald-icon>
          </emerald-input>
        </div>
        <app-job-details-filter
          [fieldsVisibility]="fieldsVisibility"
          [jobDtlsData]="rowData"
          (filteredData)="handleDataFromChild($event)"
          [requestId]="hiringRequestId"
        ></app-job-details-filter>
      </div>
    </div>
    <div class="job_details-table">
      <ng-container *ngIf="displayData && totalCount > 0; else noDataTemplate">
        <emerald-datatable
          [columnDefs]="columnDefs"
          [rowData]="displayData"
          [paginationParams]="paginationParams"
          [customCellTemplate]="{
            resumePath: customResumeColumn,
            additionalDocumentsPath: customAttachmentsColumn,
            url: customLinkColumn,
            earliestAvailability: customAvailableByColumn,
            createdDate: customReceivedOnColumn,
            action: customActionColumn,
          }"
        >
        </emerald-datatable>
      </ng-container>
      <ng-template #noDataTemplate>
        <section class="records-container" aria-label="Records section">
          <div class="empty-state">
            <ng-container *ngIf="isDataLoaded">
              <h2 class="empty-state-title">{{ errorMsg }}</h2>
            </ng-container>
            <img
              [src]="imageSrc"
              alt="No records illustration"
              class="empty-state-image"
            />
          </div>
        </section>
      </ng-template>
      <ng-template #customResumeColumn let-level="level" let-eachRow="eachRow">
        <emerald-button
          *ngIf="eachRow?.resumePath"
          className="small_button"
          [type]="'Light'"
          [label]="''"
          [size]="'Small'"
          [icon]="'download'"
          (onClick)="
            downloadFile(eachRow.resumePath, eachRow.candidateName, 'resume')
          "
        ></emerald-button>
      </ng-template>
      <ng-template
        #customAttachmentsColumn
        let-level="level"
        let-eachRow="eachRow"
      >
        <emerald-button
          *ngIf="eachRow?.additionalDocumentsPath"
          className="small_button"
          [type]="'Light'"
          [label]="''"
          [size]="'Small'"
          [icon]="'download'"
          (onClick)="
            downloadFile(
              eachRow.additionalDocumentsPath,
              eachRow.candidateName,
              'attachments'
            )
          "
        ></emerald-button>
      </ng-template>
      <ng-template #customLinkColumn let-level="level" let-eachRow="eachRow">
        <a
          class="link-color"
          (click)="openUrlNewTab(eachRow?.url)"
          [href]="eachRow?.url | addHttps"
          >{{
            eachRow?.url?.length > urlDisplayLimit
              ? eachRow?.url?.substring(0, urlDisplayLimit) + "..."
              : eachRow?.url
          }}</a
        >
      </ng-template>
      <ng-template
        #customAvailableByColumn
        let-level="level"
        let-eachRow="eachRow"
      >
        <span>{{
          eachRow?.earliestAvailability | date: dateFormat.Month
        }}</span></ng-template
      >
      <ng-template
        #customReceivedOnColumn
        let-level="level"
        let-eachRow="eachRow"
      >
        <span>{{
          eachRow?.createdDate | date: dateFormat.Month
        }}</span></ng-template
      >
      <ng-template #customActionColumn let-level="level" let-eachRow="eachRow">
        <div class="button-container">
          <app-candidate-feedback
            (sendFeedbackStatus)="receiveData($event, eachRow?.candidateId)"
            [candidateId]="eachRow?.candidateId"
            [fieldsVisibility]="fieldsVisibility"
          ></app-candidate-feedback>
        </div>
      </ng-template>
    </div>
  </div>
</div>
